import { useCssRuntimeFeatureSupport } from "../../hooks/css-runtime.js";
import { useLayoutContext } from "../../hooks/layout-context.js";
import { useWindowScrollThreshold } from "../../hooks/scroll.js";
import { cn } from "../../utils/classnames.js";
import { useMemo } from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useIsClient } from "@bitcart/hooks";
// src/components/organisms/website-header.tsx
const WebsiteHeader = ({ className, children }) => {
	const { Link, layoutConfig: { brand, project, navigation: { rootRoutePathname } } } = useLayoutContext();
	const isClient = useIsClient();
	const { isScrolled } = useWindowScrollThreshold({
		axis: "vertical",
		value: 20
	});
	const isCssScrollStateTrackable = useCssRuntimeFeatureSupport({
		property: "container-type",
		value: "scroll-state"
	});
	const logoLabelText = project?.canonicalName ?? brand.name;
	const logoLabelTextFragments = useMemo(() => logoLabelText.split(" "), [logoLabelText]);
	const logoLabel = useMemo(() => logoLabelTextFragments.length > 1 ? /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("span", {
		className: "text-lg font-bold gap-1 max-lg:flex hidden flex-col leading-none",
		children: logoLabelTextFragments.map((textFragment) => /* @__PURE__ */ jsx("span", { children: textFragment }, textFragment))
	}), /* @__PURE__ */ jsx("span", {
		className: "text-2xl font-bold max-lg:hidden",
		children: logoLabelText
	})] }) : /* @__PURE__ */ jsx("span", {
		className: "text-2xl font-bold",
		children: logoLabelText
	}), [logoLabelText, logoLabelTextFragments]);
	return /* @__PURE__ */ jsx("header", {
		className: cn(`inset-x-0 h-16 top-0 @document/scroll-top:glassy @document/scroll-top:shadow-lg fixed z-40`, {
			"bg-transparent": isClient && !isCssScrollStateTrackable && !isScrolled,
			glassy: isClient && !isCssScrollStateTrackable && isScrolled
		}, className),
		children: /* @__PURE__ */ jsx("div", {
			className: "max-w-8xl px-4 md:px-6 lg:px-8 mx-auto",
			children: /* @__PURE__ */ jsxs("div", {
				className: "h-16 flex items-center justify-between",
				children: [/* @__PURE__ */ jsxs(Link, {
					href: rootRoutePathname,
					className: cn(`
              rounded-lg p-1 px-2 text-foreground
              hover:text-primary-text
              focus-visible:text-primary-text
              transition-scale gap-3
              focus-visible:outline-ring/90
              flex items-center duration-200
              hover:scale-105
              focus-visible:outline-3
              [#root:has(#main-content-link:focus)_&]:opacity-0
            `),
					children: [/* @__PURE__ */ jsx("div", {
						className: "size-10 flex items-center justify-center",
						children: /* @__PURE__ */ jsx("img", {
							alt: "",
							src: project?.logoImageSrc ?? brand.logoImageSrc,
							className: "size-10"
						})
					}), logoLabel]
				}), /* @__PURE__ */ jsx("div", {
					className: "gap-4 h-9 flex items-center",
					children
				})]
			})
		})
	});
};
export { WebsiteHeader };

//# sourceMappingURL=website-header.js.map